<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-lightning`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_cb2d71207a__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_cb2d71207a__a)"><path d="M24.8836,43.2128L38.7025,22.5343C39.245000000000005,21.7218,39.025,20.6238,38.21,20.0825C37.919200000000004,19.889,37.5775,19.785899999999998,37.227900000000005,19.786L26.3627,19.786L26.3627,6.7680299999999995C26.3627,5.791791,25.5696,5,24.591,5C23.9983,5,23.4453,5.295341,23.116500000000002,5.7871939999999995L9.297577,26.4657C8.755005,27.2782,8.9750293,28.3756,9.789464,28.9175C10.08054,29.1112,10.42245,29.2145,10.77208,29.2145L21.6373,29.2145L21.6373,42.232C21.6373,43.2082,22.430500000000002,44,23.409100000000002,44C24.0017,44,24.555300000000003,43.7047,24.8836,43.2128Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconLightning',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
